import { render, staticRenderFns } from "./notActivityPirce.vue?vue&type=template&id=0f5ca60f&scoped=true"
import script from "./notActivityPirce.vue?vue&type=script&lang=js"
export * from "./notActivityPirce.vue?vue&type=script&lang=js"
import style0 from "./notActivityPirce.vue?vue&type=style&index=0&id=0f5ca60f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5ca60f",
  null
  
)

export default component.exports